import { NgModule } from '@angular/core';
import { NgxSvgComponent } from './ngx-svg.component';
import { NgxSvgService } from './services/ngx-svg.service';


const COMPONENTS_EXPORT = [NgxSvgComponent];
const COMPONENTS = [...COMPONENTS_EXPORT];
const MODULES_EXPORT = [];
const MODULES = [...MODULES_EXPORT];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...MODULES_EXPORT, ...COMPONENTS_EXPORT],
  providers: [NgxSvgService],
})
export class NgxSvgModule {
}
